import { render, staticRenderFns } from "./PrivacyGuide.vue?vue&type=template&id=312d59bb&scoped=true"
import script from "./PrivacyGuide.vue?vue&type=script&lang=js"
export * from "./PrivacyGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d59bb",
  null
  
)

export default component.exports